// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReportsContainer_wrapper__1mzqz","paggination":"ReportsContainer_paggination__10D-M"};